import 'devextreme/dist/css/dx.fluent.blue.light.compact.css'
import {SimpleLocalisationDto} from "../../models/interfaces/dtos/filtre-localisation-dto.ts";
import DropdownSelector from "../dropdown-selector";
import useLocationContext from "../../services/context/location/use-location-context.ts";

type LocationFiltersProps = {
    className?: string;
};

// Permet de gérer les filtres de localisation.
// Le composant renvoi une liste d'id de localisations à utiliser dans un filtre.
const LocalisationSelector = ({className} : LocationFiltersProps) => {
    const {isLoading, error, data, filterDataLocations, setFilterDataLocations} = useLocationContext();
    
    const handleValueChange = (levelIndex: number, selectedId: number | null) => {
        const newSelected = [...filterDataLocations];
        newSelected[levelIndex] = selectedId;

        // Réinitialiser les enfants pour l'usage dans getSelectedAndChildrenIds
        for (let i = levelIndex + 1; i < (data?.length ?? 0); i += 1) {
            newSelected[i] = null;
        }

        setFilterDataLocations(newSelected);
    };

    // Gestion des valeurs disponibles dans les menus déroulants
    const getOptionsForLevel = (levelIndex: number): SimpleLocalisationDto[] => {
        if (!data) return [];

        // Si le niveau parent n'est pas sélectionné, on affiche toutes les localisations.
        if (levelIndex === 0 || filterDataLocations[levelIndex - 1] == null) {
            return data[levelIndex].localisations;
        }

        // Sinon, on affiche uniquement les localisations filles de la localisation sélectionnée.
        return data[levelIndex].localisations.filter(
            loc => loc.parentId === filterDataLocations[levelIndex - 1]
        );
    };
    
    if (isLoading) return <div>Chargement...</div>;
    if (error || !data) return <div>Erreur de chargement</div>;
        
    return (
        <div className={className ?? "flex gap-4"}>
            {data.map((level, index) => {
                const options = getOptionsForLevel(index);
                const currentSelected = options.find(option => option.id === filterDataLocations[index]) ?? null;

                return (
                    <DropdownSelector
                        key={level.levelId}
                        items={options}
                        selectedItem={currentSelected}
                        onSelectionChanged={(e) => handleValueChange(index, e?.id ?? null)}
                        
                        displaySelector={loc => loc.name}
                        keySelector={loc => loc.id}
                        
                        placeholder={level.levelName}
                        showClearButton={index !== 0}
                    />
                );
            })}
        </div>
    )
}

export default LocalisationSelector;